import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
    baseURL: process.env.REACT_APP_API_URL || "https://api-dev.oshudstock.com",
});

export const { signIn, signOut, useSession } = authClient;
